import { CustomerType } from "@origin-digital/platform-enums";
import { CommonParameters, IMcAppType, NavFlow, Tab } from "../mcApp.types";

export const internetServiceProvisioning: IMcAppType = {
  name: "internetServiceProvisioning",
  path: "/my/internet/service-provisioning",
  description: "Internet Service Provisioning",
  parameters: {
    properties: {
      accountNumber: CommonParameters.superloopAccountNumber,
    },
  },
  navFlow: NavFlow.FOCUS,
  title: "Setup progress",
  parent: Tab.DASHBOARD,
  conditions: {
    intent: "internetServiceProvisioning",
    customerType: CustomerType.kraken,
  },
};
